import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { DfContraCnpj } from '../interfaces/df-contra-cnpj';
import { catchError, tap, filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class DfContraCnpjService {

  readonly path = '/df-contra-cnpj';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  getDfContraCnpj(code: number ): Observable<DfContraCnpj> {
    return this.http.get<DfContraCnpj>(`${this.jwtAuthService.apiUrl + this.path}/${code.toString}`);
  }

  getDfContraCnpjPage(page?: number, size?: number): Observable<PageResult<DfContraCnpj>> {
    return this.http.get<PageResult<DfContraCnpj>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}`);
  }

  getDfContraCnpjIbge(code: string ): Observable<DfContraCnpj> {
    return this.http.get<DfContraCnpj>(`${this.jwtAuthService.apiUrl + this.path}/ibge/${code}`);
  }

  getDfContraCnpjPageSearch(page?: number, size?: number, search?: string): Observable<PageResult<DfContraCnpj>> {
    return this.http.get<PageResult<DfContraCnpj>>(`${this.jwtAuthService.apiUrl + this.path}/page/get?page=${page}&size=${size}&search=${search}`);
  }

  getItemDfContraCnpjPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<DfContraCnpj>> {
    return this.http.get<PageResult<DfContraCnpj>>(`${this.jwtAuthService.apiUrl + this.path}/page/get?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  saveOrUpdate(cadastro: DfContraCnpj): Observable<DfContraCnpj> {
    return this.http.put<DfContraCnpj>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }
}

